import { combineReducers } from 'redux'
import theme, { ThemeState } from './../ThemeProvider/reducers'
import AppReducer, { AppState } from './appReducer'
import { MyDigitsState } from './../LineDetails/reducers/index.model'
import LineDetailsReducer from './../LineDetails/reducers'
import NumberCardReducer from './../common/NumberCard/reducer'
import { PairedLine, SavingNameStateInterface, SharedLine } from 'app/common/NumberCard/reducer/index.model'
import ShareLineReduser from '../common/NumberCard/reducer/shareLinesReducer'
import LineDelveReducer from 'app/LineDelve/reducers'
import { MyLineDelve } from 'app/LineDelve/reducers/index.model'
import SnackbarReducer, { ISnackbar } from 'app/common/Snackbar/reducer'
import PairLinesReducer from 'app/common/NumberCard/reducer/pairLinesReducer'
import ManageDevicesReducer from 'app/ManageDevices/reducers'
import { DeviceState } from 'app/ManageDevices/reducers/index.model'

export interface RootState {
  theme: ThemeState
  app: AppState
  loginInfo: any
  allLines: MyDigitsState
  numberCard: SavingNameStateInterface
  shareLine: SharedLine
  lineDelve: MyLineDelve
  SnackbarInfo: ISnackbar
  pairedLine: PairedLine
  manageDevices: DeviceState
}

export default combineReducers({
  theme,
  app: AppReducer,
  numberCard: NumberCardReducer,
  allLines: LineDetailsReducer,
  shareLine: ShareLineReduser,
  lineDelve: LineDelveReducer,
  SnackbarInfo: SnackbarReducer,
  pairedLine: PairLinesReducer,
  manageDevices: ManageDevicesReducer,
})
